import { checkElementVisibility } from '@/utils/checkElementVisibility'

const focusableSelector =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

const isTabbable = (element: HTMLElement, container: HTMLElement) =>
  element.tabIndex >= 0 && checkElementVisibility(element, container)

export const getFocusableElements = (container: HTMLElement) => {
  const focusableElements = container.querySelectorAll<HTMLElement>(focusableSelector)
  return Array.from(focusableElements).filter((element) => isTabbable(element, container))
}

export const getFirstFocusableElement = (container: HTMLElement) => {
  const focusableElements = container.querySelectorAll<HTMLElement>(focusableSelector)
  return Array.from(focusableElements).find((element) => isTabbable(element, container))
}
